import CycleRadioGroup from '@/components/service/cycle-radio-group';
import CategoryRadioGroup from '@/components/service/category-radio-group';
import CustomRadioGroup from '@/components/service/custom-radio-group';

export default {
  install(Vue) {
    Vue.component('CycleRadioGroup', CycleRadioGroup);
    Vue.component('CategoryRadioGroup', CategoryRadioGroup);
    Vue.component('CustomRadioGroup', CustomRadioGroup);
  }
}
